import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankChargesModel } from './bankcharges.model';
import { BankChargesService } from './bankcharges.service';
import { ActualSelected } from '../../../shared/utils';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'convfact-bankcharges',
    templateUrl: './bankcharges.component.html',
    styleUrls: ['./bankcharges.component.css'],
    standalone: false
})

export class BankChargesComponent implements OnInit {
  bankCharges = new BankChargesModel;

  constructor(
    private bankChargesService: BankChargesService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    const temp = this.route.params['_value'];
    const uid = temp['bankChargesUid'];
    if (uid != null) {
      this.bankChargesService.loadData(uid).then(bankCharges => {
        this.bankCharges = bankCharges;
      });
    }
  }

  saveData(bankCharges: BankChargesModel) {
    bankCharges.fiscalYear = parseInt(ActualSelected.yearSelected);
    bankCharges.activityUid = ActualSelected.activitySelected;
    if (bankCharges.uid == null) {
      this.bankChargesService.addData(bankCharges)
        .then(bankCharges => {
          this.bankCharges = bankCharges;
          this.returnToIndex();
        }).catch(errors => {
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Ha ocurrido un error inesperado al guardar el gasto bancario');
          }
        })
    } else {
      this.bankChargesService.editData(bankCharges.uid, bankCharges)
        .then(bankCharges => {
          this.bankCharges = bankCharges;
          this.returnToIndex();
        }).catch(errors => {
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Ha ocurrido un error inesperado al guardar el gasto bancario');
          }
        })
    }
  }

  returnToIndex() {
    this.router.navigate(['/expense/bankcharges']);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
